export default "__VITE_ASSET__DHIX_FBn__ 800w, __VITE_ASSET__lOOKOFw7__ 1280w, __VITE_ASSET__E6RGmyJ8__ 1920w";